define('bindingHandlers/fakeLabel',[
    'jquery',
    'lib/knockout'
], function ($, ko) {
    'use strict';

    //A binding handler that lets a non-label (particularly span) have the label behavior of focusing another element when clicked
    //Takes an elements id (just like the 'for' attr on a label) as its argument
    ko.bindingHandlers.fakeLabel = {
        init: function (element, valueAccessor) {
            $(element).on('click', function () {
                var id = ko.unwrap(valueAccessor());
                if(id) {
                    document.getElementById(id).click();
                }
            });
        }
    };
});

